import appLogger from "../../infra/logger/appLogger";
import platformStorage from "./platformStorage";
const KEY_SEGMENT_SEPARATOR = ".";
const VERSION_MARKER_KEY_SUFFIX = "clientStorageVersion";
export default class ClientStorage {
    platformStorage;
    moduleLogger;
    version;
    keyPrefix;
    versionMarkerKey;
    constructor({ applicationId, version, platformStorageAdapter = platformStorage, logger = appLogger.withTag("clientStorage"), }) {
        this.platformStorage = platformStorageAdapter;
        this.moduleLogger = logger;
        this.version = version;
        this.keyPrefix = `${applicationId}${KEY_SEGMENT_SEPARATOR}${version}${KEY_SEGMENT_SEPARATOR}`;
        this.versionMarkerKey = `${applicationId}${KEY_SEGMENT_SEPARATOR}${VERSION_MARKER_KEY_SUFFIX}`;
    }
    buildStorageKey(key) {
        return `${this.keyPrefix}${key}`;
    }
    parsePlainKey(storageKey) {
        return storageKey.startsWith(this.keyPrefix) ? storageKey.slice(this.keyPrefix.length) : null;
    }
    getItem(key) {
        return this.platformStorage.getItem(this.buildStorageKey(key));
    }
    setItem(key, value) {
        return this.platformStorage.setItem(this.buildStorageKey(key), value);
    }
    removeItem(key) {
        return this.platformStorage.removeItem(this.buildStorageKey(key));
    }
    async getAllKeys() {
        const storedKeys = await this.platformStorage.getAllKeys();
        return storedKeys.map((storedKey) => this.parsePlainKey(storedKey)).filter((plainKey) => plainKey !== null);
    }
    async clear() {
        const ownedKeys = await this.getAllKeys();
        await Promise.all(ownedKeys.map((plainKey) => this.removeItem(plainKey)));
    }
    async verifyStoredVersion() {
        const storedVersion = await this.platformStorage.getItem(this.versionMarkerKey);
        if (storedVersion === this.version) {
            return;
        }
        // Info rather than warn: every release that bumps the prefix hits this once per client,
        // which is expected rather than a defect worth reporting from production.
        this.moduleLogger.info(`stored version "${storedVersion ?? "none"}" differs from the current version "${this.version}"; values kept under the previous prefix are no longer readable`);
        await this.platformStorage.setItem(this.versionMarkerKey, this.version);
    }
    defaultCatch = (storageError) => {
        this.moduleLogger.error(`storage operation failed via the ${this.platformStorage.adapterName} adapter`, storageError);
    };
}
